import { i18n } from "../../i18n/i18n";

import React, { Component, Fragment } from 'react'
import Checkbox from '../../components/Checkbox'
import InputScan from '../../components/InputScan'
import InputText from '../../components/InputText'
import Textarea from '../../components/Textarea'
import SearchPicker, { SearchPickerOption } from '../../components/SearchPicker'
import Select, { SelectOption } from '../../components/Select'
import Button from '../../components/Button'
import routes from '../../routes/routes'
import { Link } from 'react-router-dom'
import Row from '../../components/Row/Row'


interface Props {
  interShip: boolean
  quickPO: boolean
  purchaseOrder: string
  pallet: string
  itemId: string
  item: string
  quantity: string
  reference: string
  sku: string
  productId: string
  batchLotNumber: string
  billOfLading: string
  notes: string
  printPalletOnly: boolean
  purchaseOrderSearchOptions: SearchPickerOption[]
  itemSearchOptions: SearchPickerOption[]
  itemSelectOptions: SelectOption[]
  handleSearch: (name: string, value: string) => void
  handleInputChange: (name: string, value: string) => void
  handleInputScan: (name: string, value: string) => void
  handleSearchSelect: (name: string, option: SearchPickerOption) => void
  handleSearchBlur: (name: string) => void
  handleCheckboxChange: (name: string) => void
}

export default class FormFields extends Component<Props> {

  get purchaseOrder () {
    return this.props.quickPO
      ? <InputText
        name="purchaseOrder"
        value={this.props.purchaseOrder}
        label={i18n("Purchase order")}
        onChange={this.props.handleInputChange} />
      : <SearchPicker
        name="purchaseOrder"
        value={this.props.purchaseOrder}
        options={this.props.purchaseOrderSearchOptions}
        label={i18n("Purchase order")}
        onSearch={this.props.handleSearch}
        onChange={this.props.handleInputChange}
        onSelect={this.props.handleSearchSelect}
        onBlur={this.props.handleSearchBlur} />
  }

  get item () {
    return this.props.quickPO
      ? <SearchPicker
        name="item"
        value={this.props.item}
        options={this.props.itemSearchOptions}
        label={i18n("Item")}
        onSearch={this.props.handleSearch}
        onChange={this.props.handleInputChange}
        onSelect={this.props.handleSearchSelect}
        onBlur={this.props.handleSearchBlur} />
      : <Select
        name="itemId"
        value={this.props.itemId}
        options={this.props.itemSelectOptions}
        label={i18n("Item")}
        onChange={this.props.handleInputChange} />
  }

  get reference () {
    return (
      <InputText
        name="reference"
        value={this.props.reference}
        label={i18n("Reference")}
        onChange={this.props.handleInputChange} />
    )
  }

  get interShipFields () {
    return this.props.interShip &&
      <Fragment>
        <InputScan
          name="pallet"
          value={this.props.pallet}
          label={i18n("Scan pallet")}
          onChange={this.props.handleInputChange}
          onScan={this.props.handleInputScan} />
        {this.reference}
      </Fragment>
  }

  get intraShipFields () {
    return !this.props.interShip &&
      <Fragment>
        <Row column={1}>
          {this.item}
          <Link className="flex flex-row-reverse" to={routes.itemCreate}>
            <Button text={i18n("Create Item")} onClick={()=>{}} />
          </Link>
          <br></br>
        </Row>
        <InputText
          name="quantity"
          value={this.props.quantity}
          label={i18n("Quantity")}
          onChange={this.props.handleInputChange} />
        {this.reference}
        <InputText
          name="sku"
          value={this.props.sku}
          label={i18n("SKU")}
          onChange={this.props.handleInputChange} />
        <InputText
          name="productId"
          value={this.props.productId}
          label={i18n("Product Id")}
          onChange={this.props.handleInputChange} />
        <InputText
          name="batchLotNumber"
          value={this.props.batchLotNumber}
          label={i18n("Batch/Lot number")}
          onChange={this.props.handleInputChange} />
        <InputText
          name="billOfLading"
          value={this.props.billOfLading}
          label={i18n("Bill of Lading")}
          onChange={this.props.handleInputChange} />
        <Textarea
          className='mb-0'
          name="notes"
          value={this.props.notes}
          label="Notes"
          rows={3}
          onChange={this.props.handleInputChange} />
        <Checkbox
          name="printPalletOnly"
          label="Print pallet only"
          checked={this.props.printPalletOnly}
          align="center"
          onChange={this.props.handleCheckboxChange} />
      </Fragment>
  }

  render () {
    return (
      <Fragment>
        <Checkbox
          name="interShip"
          label="Inter ship"
          checked={this.props.interShip}
          align="center"
          onChange={this.props.handleCheckboxChange} />
        <Checkbox
          name="quickPO"
          label="Quick PO"
          checked={this.props.quickPO}
          align="center"
          onChange={this.props.handleCheckboxChange} />
        {this.purchaseOrder}
        {this.interShipFields}
        {this.intraShipFields}
      </Fragment>
    )
  }
}
